<template>
    <div class="defaultButton">
        <van-button :disabled="!props.activeStatus" @click="props.onClick"
            :style="{ borderRadius:radius? radius: '15px !important', padding:btnPadding ? btnPadding : '25px !important' }">{{ title }}</van-button>
    </div>
</template>

<script setup lang="ts">
import { ref } from 'vue';
import type { PropType } from 'vue'

const props = defineProps({
    onClick: {
        type: Function as PropType<() => void>,
        required: false
    },
    title: {
        type: String,
        default: () => ''
    },
    activeStatus: {
        type: Boolean,
        default: false
    },
    radius:{
        type: String,
        default: () => ''
    },
    btnPadding: {
        type: String,
        default: () => ''
    }
})

</script>
<style scoped>
.defaultButton>.van-button--default {
    background: linear-gradient(180deg, #35A5F8 0%, #0268CB 100%);
    color: #fff !important;
    font-weight: 700;
    border: none;
    font-size: 18px;
}

.van-button--normal {
    width: 100%;
}
</style>